import { SvgIcon, SvgIconProps } from '@mui/material';

export const LocationPin = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 43 50" fill="none" {...props}>
    <g filter="url(#filter0_d_4461_67197)">
      <path
        d="M38.3159 19.1578C38.3159 26.6695 33.4888 33.0538 26.7673 35.3779C22.0264 37.3577 22.1478 43.9251 21.158 43.9251C20.1681 43.9251 20.3766 37.3577 15.5486 35.3779C8.82713 33.0538 4 26.6695 4 19.1578C4 9.68174 11.6819 1.99986 21.158 1.99986C30.634 1.99986 38.3159 9.68174 38.3159 19.1578Z"
        fill="#14151A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1616 10.3842L20.8766 9.97141L28.3063 14.2609V14.9748L27.9484 15.5948L21.5913 11.9245V17.6438L20.1615 16.8183V10.5078H20.1616V10.3842ZM26.9531 23.6214L28.306 22.8403V14.9767L27.9489 15.5953L26.9531 15.0204V23.6214ZM20.1623 25.1761V19.4567L21.5921 20.2822V26.5928H21.592V26.7162L20.877 27.129L13.4473 22.8395V22.1243L13.4474 22.1241V14.2606L14.8002 13.4796V22.0801L13.8051 21.5056L13.805 21.5057L20.1623 25.1761Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_4461_67197"
        x="0"
        y="-0.000137329"
        width="42.3159"
        height="49.9252"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4461_67197" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4461_67197"
          result="shape"
        />
      </filter>
    </defs>
  </SvgIcon>
);
